export enum SystemEnum {
  Backoffice = 1,
  TicketShop = 2,
  Distributix = 3,
  FanManagement = 4
}
